import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { baseURL } from "../../globalUtils/axiosConfig";
import { fetchDocumentField } from "../DefaultDocumentFields/redux/actions";
import { fetchDocStatuses } from "../DocumentStatuses/redux/actions";
import { fetchAllTemplates } from "../DocumentsTypesManager/redux/actions";
import { fetchRevisionStatuses } from "../RevisionStatuses/redux/actions";
import GraphSection from "./graphSection";
import ProjectsTableSection from "./tableSection";

const Projects = () => {
  const [docTypeCheckList, setDocTypeCheckList] = useState([]);
  const [docTypeOptions, setDocTypeOptions] = useState([]);
  const [statusCheckList, setStatusCheckList] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [projectDetails, setProjectDetails] = useState(null);
  const { allTemplates } = useSelector((state) => state.docTypesReducer);
  const { allDocStatuses } = useSelector((state) => state.docStatusReducer);
  const dispatch = useDispatch();
  const { project_id } = useParams();

  const fetchProjectDetails = async () => {
    const res = await axios.get(`${baseURL}/api/v1/projects/${project_id}`);
    const { success } = res.data;
    if (success) {
      const { data } = res.data;
      setProjectDetails(data);
    }
  };

  useEffect(() => {
    fetchProjectDetails();
  }, [project_id]);

  useEffect(() => {
    let search = { template_type: "project" };
    dispatch(fetchAllTemplates({ search, per_page: "all" }));
    dispatch(fetchDocStatuses());
    dispatch(fetchDocumentField());
    dispatch(fetchRevisionStatuses());
  }, []);

  useEffect(() => {
    let docOptions = allTemplates.map((el) => {
      const { name, id } = el;
      return { value: id, label: name };
    });
    setDocTypeOptions(docOptions);
  }, [allTemplates]);

  useEffect(() => {
    let statusOptions = allDocStatuses.map((el) => {
      const { status_name, id } = el;
      return { value: id, label: status_name };
    });
    setStatusOptions(statusOptions);
  }, [allDocStatuses]);

  return (
    <div className="page-top-div">
      <>
        <span className="text-span" style={{ lineHeight: "17px" }}>
          DOCUMENT CONTROL - {projectDetails?.project_number?.replace("-", "")}
        </span>
        <GraphSection project_id={project_id} />
      </>
      <ProjectsTableSection
        docTypeCheckList={docTypeCheckList}
        setDocTypeCheckList={setDocTypeCheckList}
        docTypeOptions={docTypeOptions}
        statusCheckList={statusCheckList}
        setStatusCheckList={setStatusCheckList}
        statusOptions={statusOptions}
        project_id={project_id}
      />
    </div>
  );
};

export default Projects;
